package api.data.response

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable


@Serializable
data class DataAdminProfile(
    @SerialName("userId")
    var userId: String? = null,

    @SerialName("firstName")
    var firstName: String? = null,

    @SerialName("lastName")
    var lastName: String? = null,

    @SerialName("email")
    var email: String? = null,

    @SerialName("profilePhotoUrl")
    var profilePhotoUrl: String? = null,

    @SerialName("phone")
    var phone: String? = null,
)